/**
 * @generated SignedSource<<04adf71d881d96495a7a3f6a6a067951>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useNavSettingsService$data = {
  readonly properties: {
    readonly nodes: ReadonlyArray<{
      readonly key: string | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
  readonly sidebar: {
    readonly nodes: ReadonlyArray<{
      readonly menuId: string | null;
      readonly visible: boolean | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "useNavSettingsService";
};
export type useNavSettingsService$key = {
  readonly " $data"?: useNavSettingsService$data;
  readonly " $fragmentSpreads": FragmentRefs<"useNavSettingsService">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "__relay_internal__pv__getpagesizevaluerelayproviderts"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__getpagesizevaluerelayproviderts"
    }
  ],
  "kind": "Fragment",
  "name": "useNavSettingsService",
  "selections": [
    {
      "args": (v0/*: any*/),
      "concreteType": "SettingsMenuItemConnection",
      "kind": "LinkedField",
      "name": "sidebar",
      "plural": false,
      "selections": [
        {
          "concreteType": "SettingsMenuItem",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "menuId"
            },
            {
              "kind": "ScalarField",
              "name": "visible"
            }
          ]
        }
      ]
    },
    {
      "args": (v0/*: any*/),
      "concreteType": "SettingsDisplayPropertyConnection",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "concreteType": "SettingsDisplayProperty",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "key"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ]
        }
      ]
    }
  ],
  "type": "SettingsNavigationCustomisation"
};
})();

(node as any).hash = "3eeb846e40561ac05736d40d381db293";

export default node;
